export default __webpack_public_path__ + "static/media/twitter-logo.3af7c83a.svg";